import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrML: CultureInfo = {
  name: 'fr-ML',
  displayName: 'French (Mali)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-ML',
  parent: CultureInfoFr
};
